/**
 * Created BY HMSPL 
 * Last Modified By selvakumar on 13/08/2018
 * Last Modified Description : Integrated existing login screen
 */

import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { LoginService } from '../../api-services/login.service';
import { Message } from '../../api-services/utils/error-message';
import { data } from '../../api-services/utils/static-data';
import { MasterService } from 'src/app/api-services/master.service';
import { RequestService } from 'src/app/api-services/request.service';
import { CommonService } from 'src/app/api-services/common.service';
import { ThemeService } from 'src/app/api-services/utils/theme-service';
import { MasterSales } from 'src/app/api-services/master.sales';
import { HttpParams } from '@angular/common/http';
import { AttendanceScreenComponent } from 'src/app/shared/attendance-screen/attendance-screen.component';
import { MatDialog } from '@angular/material';
import { MasterDataService } from 'src/app/api-services/master-data.service';
import * as moment from 'moment';
import { exit } from 'process';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
 public isDTCDealer = false;
  public isShowLoader = false;
  public isShowPageLoader = false;
  public dealerRoles = [];
  public dtcRoles:any = [];
  public language = [];
  public CheckValidity ;
  public showpopup=0;
  public x;
  public ChangeOldPassword;
  public ChangeNewPassword;
  public ChangeConfgPassword;
  public dealer: any = {
    'DEALER_ID': '',
    'ROLE_ID': '',
    'BRANCH_ID': '',
    'lang': '',
    'LOGIN_ID': '',
    'PASSWORD': ''
  };
  public dealerBranches = [];
  public empId: any;
  public isDealerLogin : boolean = false;
  public isDTCLogin : boolean = false;
  public latitude: any;
  public longitude: any;
  public locationDealerID: any;
  constructor(private toastr: ToastrService, private httpClient: HttpClient,
    private loginService: LoginService, private router: Router,
    private route: ActivatedRoute, private masterSales: MasterSales,
    private themeService: ThemeService,
    public dialog: MatDialog,
    public MasterDataService: MasterDataService,
    private masterServices: MasterService) { }

  ngOnInit() {
  //  if (navigator.geolocation) {
  //    console.log("latitude1",this.latitude + "longitude1",this.longitude);
  //    navigator.geolocation.getCurrentPosition((position)=>{
  //      this.latitude  = position.coords.longitude;
  //      this.longitude= position.coords.latitude;
  //      console.log("latitude2",this.latitude + "longitude2",this.longitude);
  //    });
  //  } else {
  //   console.log("No support for geolocation")
  //  }
    this.language = data.language;
    this.route.url.subscribe(params => {
     if(params[0].path == "dealer"){
       this.isDTCDealer = false;
       this.dealerRoles = data.dealerRoles;
     }
     if(params[0].path == "digitalfactory"){
       this.isDTCDealer = true;
       this.dealerRoles = data.dtcRoles;
       // this.dealer.DEALER_ID = "500000001";
       // this.getDealerBranchName(500000001);
     }
     if(params[0].path == "login"){
       this.isDTCDealer = false;
       this.dealerRoles = data.dealerRoles;
     }
    });
    // this.getDealerBranchName(10891);
    // this.dealer.BRANCH_ID = 1;
    // this.dealer.DEALER_ID = 10891;
    // this.dealer.LOGIN_ID= "support"
    // this.dealer.PASSWORD= "1234"
    // this.dealer.ROLE_ID= "6"
    this.dealer.lang = "en";
    // this.login();
    var search = location.search.substring(1);
    if (search.indexOf('authToken=') != -1) {
      var accessTk = search.split('=')[1]; 
      this.httpClient.post(RequestService.baseUrl() + '/Setting/CheckTokenInfo', null, { headers: {
        "authorization" : "Bearer " + accessTk
      }}).subscribe((resp: any) => {

        this.dealer = {
          BRANCH_ID: 1,
          DEALER_ID: resp.dealerId.toString(),
          LOGIN_ID: "admin",
          PASSWORD: "1234",
          ROLE_ID:"3",
          lang:"en",
          USER_ID: resp.userId
        }
  
        this.login();  
      },(err : any) => {
        this.router.navigate([this.router.url.split('?')[0]]);
      });
    }
    else if (search) {
      this.dealer = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
      //this.login();
      console.log('dealer', this.dealer);
    }
    else {
      var authToken = localStorage.getItem('authToken');
      if(!authToken){
        this.loginService.logout();
      }  
    }
  }
  /**
   * @param {String} dealerId
   * Get all dealer branch details
   */
  getDealerBranchName(dealerId) {
   this.isShowPageLoader = true;
   if(this.isDTCDealer == true){
     if(this.dealer.DEALER_ID.toString().startsWith("50000")){
     }
     else{
       this.isShowPageLoader = false;
       this.toastr.error("Wrong DTC Code");
       this.dealer.DEALER_ID = "";
       return;
     }
   }
   if(this.isDTCDealer == false){
     if(this.dealer.DEALER_ID.toString().startsWith("50000")){
       this.isShowPageLoader = false;
       this.toastr.error("Wrong Dealer Code");
       this.dealer.DEALER_ID = "";
       return;
     }
   }
      if (dealerId) {
          if (this.dealer.DEALER_ID.trim().length == 10 && this.dealer.DEALER_ID.substring(0, 1) == '7') {
              dealerId = this.dealer.DEALER_ID.substring(1);
          }
          let reqObj: any = {};
          reqObj.DealerId = dealerId;
      this.loginService.getDealerBranchName("DealerId=" + dealerId).subscribe((resp: any) => {
        localStorage.setItem('branches', JSON.stringify(resp.data))
       if(resp.data.length == 0){
         this.isShowPageLoader = false;
         this.toastr.error("No Data Available");
         this.dealer.DEALER_ID = "";
         return;
       }
        this.dealerBranches = resp.data;
        // if(resp.data[0].DEALER_ID.toString().startsWith("50000")){
        if(resp.data.length){
         this.dealer.BRANCH_ID = resp.data[0].BRANCH_ID;
        }
        this.isShowPageLoader = false;
      });
    }
  }
  /**
   * Login user
   */
  login() {
  
    if (!this.isShowLoader) {
   // if(localStorage.getItem('userData')==null)
     // {

      this.isShowLoader = true;
      let reqObj:any ={};
      reqObj = JSON.parse(JSON.stringify(this.dealer));        
      if(reqObj.DEALER_ID.trim().length == 10 && reqObj.DEALER_ID.substring(0,1) == '7'){
        reqObj.DEALER_ID = this.dealer.DEALER_ID.substring(1);             
      }
      //this.loginService.login(this.dealer,'CheckLoginCrdentials').subscribe((resp: any) => 
      this.loginService.loginWebApi(reqObj,'/Setting/CheckLoginValidation').subscribe((resp: any) => {
        
        if(resp.statusCode==200){
         if(this.latitude != undefined && this.longitude != undefined){
           this.sendLocation(resp.data.User.DEALER_ID);
         }
          this.getToken(resp.data);
         //  this.getServiceSalesToken(resp.data);
        }
        // this.CheckLoginCondition()
        // if(this.showpopup==1)
        // return;
        if (resp && resp.data && resp.data.DealerDetail && resp.data.DealerDetail.DEALER_ID && resp.data.DealerDetail.DEALER_ID > -1) {
        
          localStorage.setItem('langId', this.dealer.lang);
          this.httpClient.get('assets/i18n/' + this.dealer.lang + '.json').subscribe(
            langResp => {
            
              localStorage.setItem('lang', JSON.stringify(langResp));
              localStorage.setItem('userData', JSON.stringify(resp));
              localStorage.setItem('isDealerLogin', JSON.stringify(this.isDealerLogin));
              if(this.dealer.DEALER_ID.toString().startsWith("50000")) {
                this.isDTCLogin = true;                
              }
              localStorage.setItem('isDTCLogin', JSON.stringify(this.isDTCLogin));
              // localStorage.setItem('theme',JSON.stringify({"isGradiant":false,"color":"#00599d"}));
              // localStorage.setItem('colorObj',JSON.stringify({"--background":"#00599d","--bg-header":"#00599d","--text-color":"#00599d","--inner-header":"rgba(0,89,157,0.5)","isGradiant":false}))
              //this.getUserTheme();
             //  this.generateWebAPILogFile();
              this.CheckLoginCondition(resp);
            });
        } else {
          //this.toastr.error(Message.INVALID_USER, 'Login');
          this.toastr.error(resp.message, 'Login');
        }
        this.isShowLoader = false;
      });
  }
      //else
      //{
      //  this.toastr.error('In One device only one could be logged in ', 'Login');
      //}
    
  }
  sendLocation(dealerID){
   this.isShowLoader = true;
   this.masterServices.get('', '/Setting/SaveDealerLocation?dealerId=' +
   dealerID + '&lat=' + this.latitude +'&lon='+ this.longitude)
       .subscribe(
         (resp: any) => {
           if (resp.statusCode == 200) {
             console.log(resp);
           }
           if (resp.statusCode == 401) {
             this.toastr.error(resp.statusMessage);
           }
           this.isShowLoader = false;
         }, error => {
           if (error.status == 401) {
             this.loginService.logout();
           }
           this.isShowLoader = false;
           this.toastr.error(error.statusText);
         }
       )
  }

  CancelInvoiceSearch()
  {
    this.showpopup=0
    this.loginService.logout1();
  }
  ChangePassword()
  {
   
    if(this.dealer.PASSWORD != this.ChangeOldPassword)
    {
    this.toastr.error( 'Please Enter Correct Old Password');
    return;
    }

    if(this.ChangeNewPassword != this.ChangeConfgPassword)
    {
    this.toastr.error( 'New Password Is Not Equal To Confirm Password');
    return;
  }
  if(this.ChangeNewPassword == this.ChangeOldPassword)
  {
  this.toastr.error( 'New Password Can Not Be SAme As Old Password');
  return;
}
    
    // if (!this.ChangeNewPassword.value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,100})/)) {
    //   this.toastr.error( 'Password Must Contain Capital letter , Small Letter ,A numberic value ,Special Char And Must have min length of 8 Char');
    // }
    
    let letters = {};  
    for (let i = 0; i< this.ChangeNewPassword.length; i++) {  
    letters[this.ChangeNewPassword[i]] = (letters[this.ChangeNewPassword[i]] || 0) + 1;  
     
    }  
    // bonus points for mixing it up  
    let variations = {  
    digits: /\d/.test(this.ChangeNewPassword),  
    lower: /[a-z]/.test(this.ChangeNewPassword),  
    upper: /[A-Z]/.test(this.ChangeNewPassword),  
    nonWords: /\W/.test(this.ChangeNewPassword),  
    };  
    
    let variationCount = 0;  
    if(variations.digits==true && variations.lower==true && variations.upper==true && variations.nonWords==true)
    {

    }
    else{  
      this.toastr.error( 'Password Must Contain Capital letter , Small Letter ,A numberic value ,Special Char And Must have min length of 8 Char');  
    return;
    }  
    if(this.ChangeNewPassword.length<8)
    {
      this.toastr.error( 'Password Must  have min length of 8 Char');  
      return;
    }
 
  let params = new HttpParams();
  params = params.set('DEALER_ID', this.dealer.DEALER_ID)
    .set('BRANCH_ID',  this.dealer.BRANCH_ID)

    .set("LOGIN_ID",this.dealer.LOGIN_ID)
    .set('PASSWORD',this.ChangeNewPassword?this.ChangeNewPassword:null)
    .set('ROLE_ID',this.dealer.ROLE_ID)
   // .set('FromDate', this.FromDate ? CommonService.getReqDateFormat(this.FromDate) :null)
   // .set('ToDate', this.ToDate ? CommonService.getReqDateFormat(this.ToDate) :null)
    //.set('EnquiryNo', this.EnquiryNo?this.EnquiryNo:null )
    //this.ApproveService.getdownload(params).subscribe((resp: any) =>
    //this.loginService.login(this.dealer,'CheckLoginCrdentials').subscribe((resp: any) => 
    //this.MasterDataService.GetPurchaseInvoiceHalp(params).subscribe((resp:any)=>
    this.MasterDataService.Changepassword(params).subscribe((resp:any)=> {
    // if (resp && resp.statusCode == 200 && resp.data && resp.data._ApprovalList) {
    
      if(resp.statusCode==200){
        // this.getToken(resp.d.data);
         this.showpopup=0;
         this.loginService.logout1();
         location.reload();
         this.toastr.success( 'Password Changed Successfully');
         
       
        console.log(resp.data);
        
      
        
      }
      //console.log(this.downloadlist)
     
    // } else {
    //   this.toastr.error(resp.message);
    // }
   
  }, error => {
    this.toastr.error(error.error.Message);
    
  });
  }
  
  CheckLoginCondition(resp) {
     
     // this.loginService.loginWebApi(this.dealer,'CheckLoginVelidation').subscribe((resp: any) => {
       let dealerId:string=resp.data.DEALER_ID;
        if(resp.statusCode==200){
          
           
          this.CheckValidity=resp.data
         // console.log(resp.data.DEALER_ID);
          
          let lefttime = resp.data.Timelimit;
    
          if((resp.data.MODIFY_STATUS==0 || (lefttime<5 && lefttime>0 ) ) && this.dealer.ROLE_ID!=6 )
          {
             this.showpopup=1
             
             
          }
          else
          {
            this.showpopup=0;
             this.toastr.success(Message.LOGIN_SUCCESS, 'Login');
            //  this.router.navigate(['/homedashboard/home-dashboard']);
           // this.router.navigate(['/service/jobcard']);
            // this.toastr.success(Message.LOGIN_SUCCESS, 'Login');
            // 
          }
         
          
        }
        if (this.dealer.DEALER_ID.trim().length  == 10 && this.dealer.DEALER_ID.substring(0, 1) == '7') {
          this.router.navigate(['/uvd/uvd-service/uvd-job-card']);
      } else {
          this.router.navigate(['/homedashboard/home-dashboard']);
      }
        
     // });
  
     
    
  }
  getToken(data){
    let obj={
      "dealerId":data.User.DEALER_ID,
      "branchId":data.User.BRANCH_ID,
      "roleId":Number(this.dealer.ROLE_ID),
      "loginId":data.User.LOGIN_ID,
      "userId":data.User.USER_ID
}

    this.loginService.token(obj,'Setting/tokenGeneration').subscribe((resp: any) => {
      if(resp){
        localStorage.setItem('authToken',resp.access_token);
      }
    })
  }

//    getServiceSalesToken(data){
//      let obj={
//        "DealerId":data.User.DEALER_ID,
//        "BranchId":data.User.BRANCH_ID,
//        "RoleId":Number(this.dealer.ROLE_ID),
//        "LoginId":data.User.LOGIN_ID,
//        "UserId":data.User.USER_ID
//  }

//      this.loginService.tokenGenerationServiceSales(obj,'Setting/tokenGeneration').subscribe((resp: any) => {
//        if(resp){
//          localStorage.setItem('authToken',resp.access_token);
//        }
//      })
//    }
  getUserTheme() {
    this.masterServices.get('', '/Setting/Theme/getUserTheme?dealerID='
      + CommonService.getUserData().DEALER_ID
      + '&branchId=' + CommonService.getUserData().BRANCH_ID
      + '&userId=' + CommonService.getUserData().USER_ID
    ).subscribe(
      (resp: any) => {
        this.router.navigate(['/service/jobcard']);
        if (resp && resp.themeDetails) {          
          if (resp.themeDetails.isGradiant == true) {
            localStorage.setItem('theme', JSON.stringify({
              category: resp.themeDetails.gradiantName,
              isGradiant: true
            }));
          } else {
            let colorObj = {
              '--background': resp.themeDetails.background,
              '--bg-header': resp.themeDetails.backgroundHeader,
              '--text-color': resp.themeDetails.textColor,
              '--inner-header': this.changeRgba(resp.themeDetails.background),
              isGradiant: false
            }
            this.themeService.setActiveThem(colorObj);
            localStorage.setItem('theme', JSON.stringify({ isGradiant: false, color: resp.themeDetails.background }));
            localStorage.setItem('colorObj', JSON.stringify(colorObj));
          }
        };
        localStorage.setItem('userThemeDetails', JSON.stringify(resp.themeDetails));

      },
      error => {
        this.isShowLoader = false;
        // this.toastr.error(error.error.Message);
      }
      )
  }

  generateWebAPILogFile() {
    this.masterSales.get('', '/Master/GenerateLogFiles').subscribe(
      resp => {

      },
      error => {

      }
    )
  }
  changeRgba(hexCode) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hexCode)) {
      c = hexCode.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.5)';
    }
  }
  //Added By Sapna
  openEmpAttendance(attendanceData: any) {
    
      let reqParam = new HttpParams();
      reqParam = reqParam.set("DealerId", CommonService.getUserData().DEALER_ID)
          .set("branchId", CommonService.getUserData().BRANCH_ID)
          .set("attendanceDate", moment(new Date).format("YYYY-MM-DD"))
          .set("empId", attendanceData.EMPLOYEE_ID)
      this.isShowLoader = true;
      this.MasterDataService.checkEmpAttendance(reqParam).subscribe((resp: any) => {
        
          if (resp && resp.statusCode === 200) {
              if (resp.data == false) {
                  if (this.dealer.DEALER_ID.trim().length == 10 && this.dealer.DEALER_ID.substring(0, 1) == '7') {
                      this.router.navigate(['/uvd/uvd-service/uvd-job-card']);
                  } else {
                      this.router.navigate(['/uvd/uvd-service/uvd-job-card']);
                  }
              }
              else {
                  const dialogRef = this.dialog.open(AttendanceScreenComponent, {
                      width: '1000px',
                      data: { userData: attendanceData },
                      disableClose: true
                  });
                  dialogRef.afterClosed().subscribe(result => {
                      // if (result && result.length > 0) {
                      if (this.dealer.DEALER_ID.trim().length == 10 && this.dealer.DEALER_ID.substring(0, 1) == '7') {
                          this.router.navigate(['/uvd/uvd-service/uvd-job-card']);
                      } else {
                          this.router.navigate(['/uvd/uvd-service/uvd-job-card']);
                      }
                      // }
                  });
              }
          }
          this.isShowLoader = false;
      }, error => {
          this.toastr.error(error.Message);
          this.isShowLoader = false;
      });
  }
}

